export var MIN_SCROLL_SIZE = 20;
export var defaultScrollbarState = {
  size: 0,
  pos: 0,
  // Mouse is moving where big scrollbar can be located.
  hover: false,
  active: false,
  // True when scroll is following mouse (mouse down on scroll).
  scrollingByMouseDrag: false,
  scrollState: 'begin'
};
export var scrollSizeParametersNames = {
  x: {
    offset: 'offsetWidth',
    size: 'scrollWidth',
    pos: 'scrollLeft',
    coord: 'clientX',
    clientSize: 'clientWidth',
    customScrollPos: 'left',
    customScrollSize: 'width'
  },
  y: {
    offset: 'offsetHeight',
    size: 'scrollHeight',
    pos: 'scrollTop',
    coord: 'clientY',
    clientSize: 'clientHeight',
    customScrollPos: 'top',
    customScrollSize: 'height'
  }
};